import { Link } from "react-router-dom";

interface LogoProps {
  compact?: boolean;
}

export default function Logo({ compact = false }: LogoProps) {
  return (
    <Link to="/" className="flex items-center gap-2.5 cursor-pointer group" aria-label="51网址导航首页">
      <span className="w-10 h-10 rounded-lg bg-gradient-to-br from-primary-500 to-primary-700 text-background-50 flex items-center justify-center font-heading font-extrabold text-lg shrink-0">
        51
      </span>
      {!compact && (
        <span className="flex flex-col leading-none">
          <span className="font-heading font-extrabold text-lg text-foreground-950 group-hover:text-primary-600 transition-colors">
            51网址导航
          </span>
          <span className="text-[11px] text-foreground-500 tracking-wide mt-0.5 hidden sm:block">
            权威实用网址快速访问门户
          </span>
        </span>
      )}
    </Link>
  );
}